var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1027 3.59606L10.1302 4.56852C10.031 4.66766 9.87073 4.66766 9.77158 4.56852L7.43007 2.22702C7.33092 2.12787 7.33092 1.96755 7.43007 1.86841L8.40254 0.895949C8.79701 0.50148 9.43829 0.50148 9.83487 0.895949L11.1027 2.16373C11.4992 2.5582 11.4992 3.19948 11.1027 3.59606ZM6.59472 2.70376L1.05524 8.24319L0.608036 10.8062C0.546861 11.1521 0.848516 11.4517 1.19447 11.3926L3.75748 10.9433L9.29695 5.40386C9.3961 5.30472 9.3961 5.1444 9.29695 5.04525L6.95544 2.70376C6.85418 2.60461 6.69386 2.60461 6.59472 2.70376V2.70376ZM3.21745 7.76857C3.10143 7.65254 3.10143 7.46691 3.21745 7.35089L6.46604 4.10233C6.58206 3.98631 6.7677 3.98631 6.88372 4.10233C6.99974 4.21835 6.99974 4.40398 6.88372 4.52L3.63513 7.76857C3.51911 7.88459 3.33347 7.88459 3.21745 7.76857V7.76857ZM2.45593 9.54262H3.46848V10.3084L2.10787 10.5467L1.45182 9.89068L1.6902 8.53008H2.45593V9.54262Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c450d74f8863db4a11da6f09e3e42da8.svg";
export { ForwardRef as ReactComponent };